module.exports = __webpack_public_path__ + "iphoneduo-night-sky.0b4712c9.png";